import { useTranslation } from 'react-i18next';

const API_BASE = (import.meta.env.VITE_API_URL as string | undefined) || '';

/**
 * Branded OAuth buttons. The href points at the backend's OAuth start
 * route so partner-side redirects work end-to-end without React-side
 * state. Apple is rendered second by Apple's convention. We keep both
 * always visible — if Apple is unconfigured server-side the backend
 * responds 503 and the user gets an honest error on /login?auth=...
 */
export function OAuthButtons() {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 gap-2">
      <a
        href={`${API_BASE}/auth/google`}
        className="inline-flex items-center justify-center gap-2.5 px-4 py-2.5 rounded-lg bg-white border border-ink-200 hover:border-ink-300 transition text-[14px] font-semibold text-ink-900 shadow-card"
      >
        <GoogleIcon />
        {t('auth.continue_with_google', { defaultValue: 'Continue with Google' })}
      </a>
      <a
        href={`${API_BASE}/auth/apple`}
        className="inline-flex items-center justify-center gap-2.5 px-4 py-2.5 rounded-lg bg-ink-900 hover:bg-ink-800 transition text-[14px] font-semibold text-white shadow-card"
      >
        <AppleIcon />
        {t('auth.continue_with_apple', { defaultValue: 'Continue with Apple' })}
      </a>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
      <path
        d="M21.6 12.227c0-.709-.064-1.388-.182-2.045H12v3.868h5.382a4.598 4.598 0 0 1-1.995 3.022v2.51h3.227c1.89-1.74 2.986-4.305 2.986-7.355z"
        fill="#4285F4"
      />
      <path
        d="M12 22c2.7 0 4.964-.895 6.614-2.418l-3.227-2.51c-.895.6-2.04.954-3.387.954-2.604 0-4.81-1.76-5.595-4.123H3.073v2.59A9.997 9.997 0 0 0 12 22z"
        fill="#34A853"
      />
      <path
        d="M6.405 13.903a6.013 6.013 0 0 1 0-3.806V7.507H3.073a9.99 9.99 0 0 0 0 8.986l3.332-2.59z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.977c1.468 0 2.786.505 3.823 1.496l2.867-2.867C16.96 2.987 14.695 2 12 2 8.118 2 4.768 4.227 3.073 7.507l3.332 2.59C7.19 7.737 9.396 5.977 12 5.977z"
        fill="#EA4335"
      />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
      <path d="M16.365 1.43c0 1.14-.467 2.286-1.262 3.108-.842.871-2.222 1.547-3.355 1.445-.137-1.107.46-2.286 1.196-3.058.844-.881 2.295-1.55 3.42-1.495zM20.5 17.13c-.535 1.21-1.18 2.41-1.992 3.488-1.123 1.49-2.708 3.345-4.667 3.365-1.78.018-2.246-1.143-4.65-1.131-2.405.012-2.93 1.155-4.71 1.137-1.96-.02-3.42-1.7-4.55-3.19C-.78 17.45-.79 12.06 2.18 9.215c1.2-1.142 2.847-1.85 4.567-1.83 1.787.025 3.474 1.175 4.535 1.175 1.05 0 3.087-1.45 5.21-1.235.886.037 3.376.355 4.978 2.682-4.247 2.327-3.563 8.402-.97 7.123z" />
    </svg>
  );
}
